import { FC } from 'react'
import { SelfreflectionQuestionBoolean } from '../../../types'
import { Row } from 'antd'
import { useTranslation } from 'react-i18next'
import TrueFalseSwitch from '../../../components/formik-component/TrueFalseSwitch'
import { FormItem, Checkbox } from '../../../components/formik-component'

type Props = {
  questionBooleanInput: SelfreflectionQuestionBoolean
  employeeId: number
  meetingId: number
  questionId: number
  isTick?: boolean
  disabled?: boolean
  formName?: string
  subItemPosition: number
}

export const SelfreflectionQuestionBooleanTemplate: FC<Props> = ({
  questionBooleanInput,
  isTick,
  disabled = false,
  formName,
  subItemPosition,
}) => {
  const [t] = useTranslation()

  const value = questionBooleanInput
    ? questionBooleanInput.value !== undefined && questionBooleanInput.value !== null
      ? questionBooleanInput.value
      : false
    : false
  const textId = questionBooleanInput ? questionBooleanInput.textId : null

  return (
    <>
      {isTick ? (
        <Row type="flex" justify="center">
          <FormItem name={`${formName}.subItems.0.value`}>
            <TrueFalseSwitch name={`${formName}.subItems.0.value`} disabled={disabled} currentValue={value} />
          </FormItem>
        </Row>
      ) : (
        <Checkbox
          data-e2e-selfreflection-checkbox={textId}
          name={`${formName}.subItems.${subItemPosition}.value`}
          checked={value ? value : undefined}
          disabled={disabled}
        >
          {t(`appraisalMeeting.selfReflection.booleans.${textId}`)}
        </Checkbox>
      )}
    </>
  )
}
